import React from "react";
import {formatBlogDate} from "../../utils/blogs";
import "./BlogCard.scss";

export default function BlogCard({blog, isFeatured, onSelectPost}) {
  return (
    <article
      className={
        `blog-card ${isFeatured ? "blog-card-featured" : ""} ${
          blog.source === "medium" ? "blog-card-medium" : "blog-card-custom"
        }`
      }
    >
      {blog.coverImage ? (
        <div className="blog-card-cover">
          <img src={blog.coverImage} alt={blog.title} />
        </div>
      ) : null}

      <div className="blog-card-top-row">
        <span className="blog-card-source">
          {blog.source === "medium" ? "Medium" : "Portfolio note"}
        </span>
        <span className="blog-card-meta-chip">{blog.readingTime} min</span>
      </div>

      <h3 className="blog-title">{blog.title}</h3>

      <p className="small">
        {blog.excerpt || blog.description}
      </p>

      {blog.tags && blog.tags.length > 0 ? (
        <div className="blog-tag-row">
          {blog.tags.slice(0, 3).map(tag => (
            <span className="blog-tag" key={`${blog.id}-${tag}`}>
              {tag}
            </span>
          ))}
        </div>
      ) : null}

      <div className="blog-card-footer">
        <div className="blog-card-stats">
          <span className="blog-card-date">{formatBlogDate(blog.updatedAt || blog.createdAt)}</span>
          <span className="blog-card-engagement">{blog.likesCount || 0} likes</span>
          <span className="blog-card-engagement">{blog.commentCount || 0} comments</span>
        </div>
        <button className="blog-card-action" onClick={() => onSelectPost(blog)} type="button">
          Read
        </button>
      </div>
    </article>
  );
}
